module.exports = __webpack_public_path__ + "static/img/policyType4-info.0e722480.png";